import { Panel, Table } from 'react-bootstrap';
import styled from 'styled-components';

export const PanelTitleWrapper = styled(Panel.Title)`
    & > a {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
`;

export const TableContainer = styled.div`
    height: 500px;
    overflow-y: auto;
`;

export const TableWrapper = styled(Table)`
    & > thead th {
        position: sticky;
        top: 0; /* Sticks the header to the top of its container */
        background-color: #022644; /* Essential to cover content underneath */
        color: white;
        z-index: 1; /* Ensures the header stays above the table body rows */
    }

    & > thead > tr > th {
        vertical-align: bottom;
    }

    & > tbody > tr > td {
        vertical-align: middle;
    }

    & > tbody:nth-child(odd) {
        background-color: #eee;
    }
`;

export const ConfirmTableWrapper = styled(Table)`
    & > thead > tr > th,
    & > tbody > tr > td {
        text-align: center;
    }
`;